import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const SystemPlugin = () => (
  <div>System Plugin</div>
);

export default withStyles(styles)(SystemPlugin);

